import { Component, Input } from '@angular/core';

@Component({
    selector: 'smart-image',
    templateUrl: './smart-image.component.html',
    styleUrls: ['./smart-image.component.scss'],
    standalone: false
})
export class SmartImageComponent {

  @Input() url: string;

  @Input() width = '100%';

  @Input() height = '100%';

  @Input() type = 'cover';

  constructor() {
  }
}
